<template>
	<form autocomplete="off">
		<div class="container-fluid no-select" ref="contentBaseCreditFormContainer" v-cloak>

			<div class="row row-your-package" v-if="packageMode">
				<div class="col-12 mt-3">
					<h4 class="text-center"><span class="text-black mb-3">Your Bundle: </span><span class="text-black">{{pckName}}</span></h4>
				</div>
				<div class="col-12 col-no-dp-no-v" v-show="NoDP_NoV">
					<h4><span class="text-black">${{strNrCredits}}</span></h4>
				</div>
				<div class="col-12 col-yes-dp-no-v" v-show="YesDP_NoV">
					<h3><span class="text-gray strike-gray">${{strNrCredits}}</span><span class="text-black ms-3">${{strDiscPerNrCredits}}</span></h3>
					<p><span class="text-green fw-bold">You save ${{strDiscPerSavedNrCredits}} ({{strDiscPerPct}}%)</span></p>
				</div>
				<div class="col-12 col-no-dp-yes-v" v-show="NoDP_YesV">
					<h3><span class="text-gray strike-gray">${{strNrCredits}}</span><span class="text-black ms-3">${{strVoucherNrCredits}}</span></h3>
					<p><span class="text-green fw-bold">You save ${{strVoucherSavedNrCredits}} ({{strVoucherPct}}%)</span></p>
				</div>
			</div>

			<div class="row" v-show="!paymentSuccess">
				<div class="col-12 mt-3">
					<h5 class="text-center text-gray">Pay With Your ContentBASE Account Credit</h5>
				</div>
				<div class="col-lg-4 order-lg-1 order-3 mt-3 center-all col-loading-indicator" v-show="processing">
					<img src="/img/loaders/Pulse-1s-200px.png" class="img-account-credit-loader">
				</div>
				<div class="col-lg-4 order-lg-1 order-3 mt-3 center-all col-promo-code"  v-show="!processing">
					<voucher @code-applied="updateVoucherCode($event)" @code-removed="updateVoucherCode($event)" v-show="showVoucher"></voucher>
				</div>
				<div class="col-lg-4 order-lg-2 order-2 mt-3 center-all col-buy-button">
					<button class="btn btn-primary button-account-credit-submit" :disabled="processing" @click="clickPurchase">PAY NOW</button>
				</div>
				<div class="col-lg-4 order-lg-3 order-1 mt-3 center-all col-account-credit">
					<img src="/img/credits/contentbase-credit-dollar.png" class="img-account-credit">
					<span class="fw-bold ms-2">{{strUserNrCredits}}</span>
				</div>

				<div class="col-12 mt-3" v-show="paymentFailure">
					<h5 class="text-center m-0"><span class="text-danger fw-bold">You are {{nrCreditsShort}} short.</span></h5>
					<h5 class="text-center m-2"><span class="fw-bold"><a href="/credit/" target="_blank" rel="nofollow"><u>Click here</u></a> to top up your account credit.</span></h5>
				</div>
			</div>

			<div class="row mt-3" ref="rowPaymentSuccess" v-show="paymentSuccess">
				<div class="col-12">
					<h5 class="text-center">Payment successfully processed!</h5>
					<p class="big-bold-black text-center">{{enjoyMessage}}</p>
				</div>
			</div>

		</div>
	</form>
</template>




<script>

	import voucher from '../common/Voucher.vue';

	export default {
		mixins: [mixinAxios],
		components: {
			voucher
		},
		data: () => ({
			processing: false,
			paymentFailure: false,
			paymentSuccess: false,
			voucher : {},
			creditSpend : {},
			userNrCredits : 0
		}),
		props: {
			// which mode: credit/package
			mode                : { type: String, default: null },

			// buying account credit mode
			crdNrCredits        : { type: Number, default: 0 },

			// buying package mode
			pckId               : { type: Number, default: 0 },
			pckName             : { type: String, default: null },
			pckNrCredits        : { type: Number, default: 0 },
			pckDiscPerId        : { type: Number, default: null },
			pckDiscPerNrCredits : { type: Number, default: null },

			// other info
			usrNrCredits        : { type: Number, default: 0 }
		},
		mounted() {
			this.userNrCredits = this.usrNrCredits;
		},
		methods: {
			spendAccountCreditOnPackage() {
				var packageIDAndVoucherID = {
					packageID : this.pckId,
					voucherID : this.voucher?.id ?? 0,
					voucherCode : this.voucher?.code ?? ''
				};

				return this.mixinAxios().post('/api/user/SpendAccountCreditOnPackage', packageIDAndVoucherID)
					.then((result) => {
						var vals = result.data.vals;
						var data = result.data;

						this.creditSpend = data.data;
						this.userNrCredits = vals.nrCredits;
						var paymentCompleted = this.creditSpend?.success ?? false;

						// payment completed, so handle it
						if (data.success && paymentCompleted) {
							this.setStateToStopProcessing(true);
							this.broadcast(vals.nrCredits);
							//this.showSparkles();
							this.$emit('payment-completed');
						} else {
							this.setStateToStopProcessing();
						}
					})
					.catch(() => {
						//console.log('spendAccountCreditOnPackage() - Fail()');
						this.setStateToStopProcessing();
					});
			},
			resetDefaultView() {
				this.paymentFailure = false;
				this.paymentSuccess = false;
			},
			broadcast(nrCredits) {
				Broadcaster.TransmitCreditsRefresh(nrCredits).then(() => {
				});
			},
			showSparkles() {
				var element = this.$refs['rowPaymentSuccess'];

				party.sparkles(element, {
					count: party.variation.range(50, 50),
				});
			},
			setStateToStartProcessing() {
				this.lastErrorCode  = null;
				this.processing     = true;
				this.paymentFailure = false;
				this.paymentSuccess = false;
				this.$emit('payment-started');
			},
			setStateToStopProcessing(success = false) {
				this.processing     = false;
				this.paymentFailure = !success;
				this.paymentSuccess = success;
				this.$emit('payment-stopped');
			},
			clickPurchase() {
				this.setStateToStartProcessing();
				this.spendAccountCreditOnPackage();
			},
			updateVoucherCode(voucher) {
				this.voucher = voucher;
			}
		},
		computed: {
			voucherApplied() {
				return (this.voucher.id != null);
			},
			voucherNotApplied() {
				return (!this.voucherApplied);
			},
			hasDiscountPeriod() {
				return (this.pckDiscPerId != null);
			},
			notHasDiscountPeriod() {
				return (!this.hasDiscountPeriod);
			},
			showVoucher() {
				var notCreditMode = !this.creditMode;
				return (this.notHasDiscountPeriod && notCreditMode);
			},
			NoDP_NoV() {
				return (this.notHasDiscountPeriod && this.voucherNotApplied);
			},
			YesDP_NoV() {
				return (this.hasDiscountPeriod && this.voucherNotApplied);
			},
			NoDP_YesV() {
				return (this.notHasDiscountPeriod && this.voucherApplied);
			},
			numNrCredits() {
				return this.pckNrCredits;
			},
			numDiscPerPct() {
				return (this.hasDiscountPeriod)
					? (100 - ((this.pckDiscPerNrCredits / this.pckNrCredits) * 100))
					: 0;
			},
			numDiscPerNrCredits() {
				return (this.hasDiscountPeriod)
					? this.pckDiscPerNrCredits
					: 0;
			},
			numDiscPerCreditsSaved() {
				return (this.numNrCredits - this.numDiscPerNrCredits);
			},
			numVoucherPct() {
				return (this.voucherApplied)
					? this.voucher.discountPct
					: 0;
			},
			numVoucherNrCredits() {
				return (this.voucherApplied)
					? (this.pckNrCredits * ((100 - this.voucher.discountPct) / 100))
					: 0;
			},
			numVoucherCreditsSaved() {
				return (this.numNrCredits - this.numVoucherNrCredits);
			},
			strDiscPerPct() {
				return this.numDiscPerPct?.toNrDecimals(0, 2) ?? '';
			},
			strDiscPerNrCredits() {
				return this.numDiscPerNrCredits?.toNrDecimals(2, 2) ?? '';
			},
			strDiscPerSavedNrCredits() {
				return this.numDiscPerCreditsSaved?.toNrDecimals(2, 2) ?? '';
			},
			strVoucherSavedNrCredits() {
				return this.numVoucherCreditsSaved?.toNrDecimals(2, 2) ?? '';
			},
			strVoucherPct() {
				return this.numVoucherPct?.toNrDecimals(0, 2) ?? '';
			},
			strVoucherNrCredits() {
				return this.numVoucherNrCredits?.toNrDecimals(2, 2) ?? '';
			},
			strNrCredits() {
				return this.numNrCredits?.toNrDecimals(2, 2) ?? '';
			},
			modeLower() {
				return this.mode?.toLowerCase();
			},
			creditMode() {
				return (this.modeLower == 'credit');
			},
			packageMode() {
				return (this.modeLower == 'package');
			},
			accountCredit() {
				var strNrCredits = this.crdNrCredits.toNrDecimals(2, 2);
				return `$${strNrCredits}`;
			},
			strUserNrCredits() {
				var strNrCredits = this.userNrCredits.toNrDecimals(2, 2);
				return `$${strNrCredits}`;
			},
			enjoyMessage() {
				return (this.creditMode)
					? `You have topped up your account credit by ${this.accountCredit}!`
					: (this.packageMode)
					? 'Enjoy your bundle!'
					: null;
			},
			nrCreditsShort() {
				var strNrCredits = this.creditSpend?.nrCreditsShort?.toNrDecimals(2, 2) ?? 0;
				return `$${strNrCredits}`;
			}
		},
		watch: {
		}
	};
</script>




<style scoped>

	/* COMPONENT */

	.img-account-credit-loader {
		width: 48px;
	}

	.img-account-credit {
		width: 40px;
	}

	.div-card-input {
		margin: auto;
		max-width: 400px;
	}

	.col-loading-indicator {
		height: 62px;
	}

	.col-promo-code {
		height: 62px;
	}

	.col-buy-button {
		height: 62px;
	}

	.col-account-credit {
		height: 62px;
	}

	.col-no-dp-no-v, .col-yes-dp-no-v, .col-no-dp-yes-v {
		text-align: center;
	}

	@media all and (min-width: 992px) {
		.img-account-credit {
			width: 40px;
		}

		.col-loading-indicator {
			justify-content: center !important;
		}

		.col-promo-code {
			justify-content: start !important;
		}

		.col-account-credit {
			justify-content: end !important;
		}
	}

	/* COMPONENT */




	/* BUTTON */

	.button-account-credit-submit {
		padding: 10px 40px;
		font-size: 1.2rem;
	}

	/* BUTTON */




	/* COMMON */

	[v-cloak] {
		display: none;
	}

	.text-black {
		color: black;
	}

	.text-gray {
		color: gray;
	}

	.text-green {
		color: green;
	}

	.strike-black {
		text-decoration: line-through;
		text-decoration-color: black;
	}

	.strike-gray {
		text-decoration: line-through;
		text-decoration-color: gray;
	}

	.big-bold-black {
		font-size: 1.25rem;
		font-weight: bold;
		color: black;
	}

	.big-bold-green {
		font-size: 17px;
		font-weight: bold;
		color: green;
	}

	.strike {
		text-decoration: line-through;
	}

	.underline {
		text-decoration: underline;
	}

	.center-all {
		display: flex;
		align-items: center;
		justify-content: center;
	}

	.overlay-container {
		position: relative;
	}

	.overlay {
		background: black;
		opacity: 0.1;
		position: absolute;
		top: 0px;
		left: 0px;
		width: 100%;
		height: 100%;
		z-index: 100;
	}

	/* COMMON */

</style>